import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Leistungen from './views/Leistungen.vue'
import Hinweise from './views/Hinweise.vue'
import Kontakt from './views/Kontakt.vue'
import Impressum from './views/Impressum.vue'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/leistungen',
            name: 'leistungen',
            component: Leistungen
        },
        {
            path: '/hinweise',
            name: 'hinweise',
            component: Hinweise
        },
        {
            path: '/kontakt',
            name: 'kontakt',
            component: Kontakt
        },
        {
            path: '/impressum',
            name: 'impressum',
            component: Impressum
        }
    ]
})
